<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-primary py-7 py-lg-8 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">Welcome!</h1>

              <p class="text-lead text-white">
                This is our portal to our official OBCM Website.
                <br />
              </p>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <loading
              :active.sync="isLoading"
              loader="spinner"
              color="#20A8D8"
              :is-full-page="false"
            />
            <b-card-body class="px-lg-5 py-lg-5 justify-content-center login-card">
              <div class="img-logo-small">
                <img src="img/brand/obcm-black.svg" class="img-logo" alt="OBCM Logo" />
              </div>

              <h1>Log In</h1>
              <small>Enter your credentials to proceed.</small>
              <br />
              <br />

              <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input
                    alternative
                    class="mb-3"
                    name="Email"
                    :rules="{ required: true, email: true }"
                    prepend-icon="ni ni-email-83"
                    placeholder="Email"
                    v-model="email"
                  >
                  </base-input>

                  <base-input
                    alternative
                    class="mb-3"
                    name="Password"
                    :rules="{ required: true, min: 6 }"
                    prepend-icon="ni ni-lock-circle-open"
                    type="password"
                    placeholder="Password"
                    v-model="password"
                  >
                  </base-input>

                  <b-row class="mt-3">
                    <b-col cols="6">
                      <b-button
                        type="button"
                        variant="secondary"
                        id="btn-login"
                        class="login-btn mt-4"
                        :disabled="disableConfirmButtons"
                        @click="resetLogin(true)"
                      >
                        Reset
                      </b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button
                        type="submit"
                        variant="primary"
                        id="btn-login"
                        class="login-btn mt-4"
                        :disabled="disableConfirmButtons"
                      >
                        Login
                      </b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
          <b-row class="mt-3">
            <b-col cols="6">
              <router-link to="/login" class="text-light"
                ><small>Forgot password?</small></router-link
              >
            </b-col>
            <b-col cols="6" class="text-right">
              <router-link to="/register" class="text-light"
                ><small>Create new account</small></router-link
              >
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// DAO
import userSessions from "@/database/userSessions.js";

// Others
import config from "@/config/env-config.js";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import _ from "lodash";

export default {
  name: "login",
  components: {
    Loading,
  },
  data() {
    return {
      email: "",
      password: "",

      isLoading: false,
      showPassword: false,
    };
  },
  computed: {
    disableConfirmButtons() {
      return this.isLoading;
    },
    passwordRegex() {
      return config.passwordRegex;
    },
    passwordErrorMsg() {
      return config.passwordErrorMsg;
    },
  },
  methods: {
    async onSubmit() {
      try {
        this.isLoading = true;

        const user = await userSessions.login(this.email, this.password);

        localStorage.setItem("loggedUser", JSON.stringify(user));
        localStorage.setItem("email", this.email);
        await this.redirectToDashboard(user);
      } catch (error) {
        console.error("Login error:", error);
        if (
          error.code == "auth/wrong-password" ||
          error.code == "auth/invalid-credential"
        ) {
          // if error code is wrong password, increment login attempt
          await this.setAttempts(error.code);

          this.$toaster.warning("Invalid email or password!");
          this.resetLogin(false);
          return;
        } else {
          this.$toaster.warning("Login failed. Please try again!");
          this.resetLogin(false);
          return;
        }
      }
    },
    async setAttempts() {
      let userAttempts = {
        emailAddress: this.email,
        deviceType: "web",
      };
      //call api to set attempts
      await userSessions.setUserSessionAttempts(userAttempts);
    },
    async redirectToDashboard(user) {
      this.$toaster.success("Login successful!");

      // redirect to dashboard
      this.$router.push("/dashboard");
    },
    resetLogin(resetFields) {
      // reset form fields
      if (resetFields) {
        this.email = "";
        this.password = "";
      }
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
.img-logo {
  margin-top: 10px;
  margin-bottom: 40px;
  margin-left: -40px;
  width: 55%;
}

.img-logo-small {
  width: inherit;
  text-align: center;
}

.login-card {
  padding: 30px;
  border-radius: 20px;
  background-color: #ffffff !important;
}

.login-btn {
  width: 100%;
}
</style>
